import { Card, CardContent, CircularProgress, Backdrop, Modal } from "@mui/material";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import useCompra from './useCompra';
/* import { withAuthenticationRequired } from '@auth0/auth0-react'; */
import Loading from '../../../Loading';
import moment from "moment";
import { downloadTicketPDF } from "../api";
import { useState } from 'react';
import { config } from '../../../../services/config';
import { updateTicketImage } from "../../../../views/eventos/ticket/api";
import { Share,  CalendarTodayOutlined,  FileDownloadOutlined } from "@mui/icons-material";
import NotDesign from "../../../../assets/design-not-available.png";
import TicketShareModal from "../../../modales/TicketShareModal";
import withAuthenticationRequired from "../../../ProtectedRoutes/withAuthenticationRequired";
const apiOrigin = config.URL_API;

const Compra = () => {
  const { id } = useParams();
  const { compra, loading, fetchCompra, unauthorized } = useCompra(id);
  const [refreshingTickets, setRefreshingTickets] = useState({});
  const [expandedImage, setExpandedImage] = useState(null);
  const [downloadingTickets, setDownloadingTickets] = useState({});
  const [shareModalOpen, setShareModalOpen] = useState(false);
  const [currentTicket, setCurrentTicket] = useState(null);

  const getTicketImageUrl = (ticketId) => {
    // parametro del timestamp para evitar el cacheo de la imagen
    return `${apiOrigin}/static/eventos/tickets/ticket${ticketId}.png?t=${Date.now()}`;
  };

  if (unauthorized) {
    return null;
  }

  const handleRefreshTicketImage = async (e, ticketId, eventoId) => {
    e.stopPropagation();
    e.preventDefault();

    try {
      setRefreshingTickets(prev => ({ ...prev, [ticketId]: true }));
      await updateTicketImage(eventoId, ticketId);

      // espera a que la imagen se actualice y refresca la vista
      setTimeout(() => {
        fetchCompra(id);
        setRefreshingTickets(prev => ({ ...prev, [ticketId]: false }));
      }, 1500);

    } catch (error) {
      console.error('Error al actualizar la imagen del ticket:', error);
      setRefreshingTickets(prev => ({ ...prev, [ticketId]: false }));
    }
  };

  const handleDownload = async (e, ticketId) => {
    if (!ticketId) return;

    e.stopPropagation();
    e.preventDefault();

    try {
      setDownloadingTickets(prev => ({ ...prev, [ticketId]: true }));

      const pdfBlob = await downloadTicketPDF(ticketId);

      const url = window.URL.createObjectURL(pdfBlob);

      // obtengo los datos del evento 
      const eventoNombre = compra?.carrito?.evento?.evento || 'evento';
      const ticketInfo = compra?.tickets?.find(t => t.id === ticketId);
      const ticketTipo = ticketInfo?.tarifa?.concepto || 'ticket';

      // crear un nombre de archivo único
      const fileName = `${eventoNombre.replace(/\s+/g, '_')}_${ticketTipo.replace(/\s+/g, '_')}_${ticketId}.pdf`;

      // crear un enlace temporal para descargar el archivo
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();

      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);

    } catch (error) {
      console.error('Error al descargar el ticket:', error);
    } finally {
      setDownloadingTickets(prev => ({ ...prev, [ticketId]: false }));
    }
  };

  const handleShare = (e, ticketId) => {
    e.stopPropagation();
    e.preventDefault();

    setCurrentTicket(ticketId);
    setShareModalOpen(true);
  };

  const handleCloseShareModal = () => {
    setShareModalOpen(false);
    setCurrentTicket(null);
  };

  const handleExpandImage = (ticketId) => {
    setExpandedImage(ticketId);
  }

  const handleCloseImage = () => {
    setExpandedImage(null);
  }

  return (
    <div className="container-fluid" style={{ padding: "20px", height: '100%', width: '100%' }}>
      {loading ? (
        <div className="d-flex justify-content-center my-4">
          <CircularProgress />
        </div>
      ) : (
        <div style={{ marginTop: '20px', height: '100%', width: '100%' }}>
          <div className="d-flex justify-content-center align-items-center flex-wrap gap-4">
            {compra?.tickets?.map((ticket) => (
              <Card key={ticket.id} sx={{
                maxWidth: "350px",
                height: "auto",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                overflow: 'hidden'
              }}
                onClick={() => handleExpandImage(ticket.id)}
              >
                <div style={{ position: 'relative' }}>
                  <img
                    src={getTicketImageUrl(ticket.id)}
                    alt={`Ticket ${ticket.id}`}
                    style={{
                      width: "100%",
                      display: "block",
                    }}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = NotDesign;
                    }}
                  />

                  {/* <Tooltip title="Actualizar diseño del ticket" arrow>
                    <IconButton
                      size="small"
                      onClick={(e) => handleRefreshTicketImage(e, ticket.id, compra.carrito.idevento)}
                      sx={{
                        position: 'absolute',
                        top: '8px',
                        right: '10px',
                        backgroundColor: 'rgba(255, 255, 255, 0.5)',
                        '&:hover': {
                          backgroundColor: 'rgba(255,255,255,0.9)',
                        },
                        color: refreshingTickets[ticket.id] ? '#5656FF' : '#6B7280'
                      }}
                    >
                      {refreshingTickets[ticket.id] === true ? (
                        <CircularProgress size={20} sx={{ color: '#5656FF' }} />
                      ) : (
                        <Replay fontSize="small" />
                      )}
                    </IconButton>
                  </Tooltip> */}

                  {refreshingTickets[ticket.id] === true && (
                    <div style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      backgroundColor: 'rgba(255, 255, 255, 0.7)',
                    }}>
                      <CircularProgress size={40} sx={{ color: '#5656FF' }} />
                    </div>
                  )}
                </div>

                <CardContent>
                  <h5 style={{
                    fontWeight: 600,
                    color: '#0B0060',
                    marginBottom: '4px',
                    fontFamily: "Bricolage Grotesque",
                    fontSize: '18px'
                  }}>
                    {compra?.carrito?.evento?.evento}
                  </h5>

                  <p style={{
                    color: '#525252',
                    margin: '8px 0',
                    fontSize: '14px',
                    fontWeight: 500,
                    fontFamily: "Bricolage Grotesque"
                  }}>
                    {ticket?.tarifa.concepto}
                  </p>

                  <div style={{ display: 'flex', alignItems: 'center', marginBottom: '12px' }}>
                    <CalendarTodayOutlined sx={{ fontSize: "14px", color: '#5656ff', marginRight: "5px" }} />
                    <span style={{
                      fontSize: '14px',
                      color: '#525252',
                      fontFamily: "Bricolage Grotesque"
                    }}>
                      {moment(ticket.tarifa?.fechas?.[0]?.fecha.hora_inicio).clone().local().format("MMMM DD, YYYY")}
                    </span>
                  </div>

                  <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginTop: '12px',
                    gap: "10px"
                  }}>
                    <button
                      type="button"
                      onClick={(e) => handleDownload(e, ticket.id)}
                      style={{
                        border: "1px solid #5656FF",
                        color: "#5656FF",
                        padding: "5px 10px",
                        borderRadius: "4px",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: window.innerWidth <= 576 ? "13px" : "14px",
                        width: "100%",
                        opacity: downloadingTickets[ticket.id] ? 0.7 : 1
                      }}
                    >
                      {downloadingTickets[ticket.id] ? (
                        <>
                          <CircularProgress size={16} sx={{ color: '#5656FF', marginRight: "4px" }} />
                          Descargando...
                        </>
                      ) : (
                        <>
                          <FileDownloadOutlined fontSize="small" style={{ marginRight: "4px" }} />
                          Descargar
                        </>
                      )}
                    </button>

                    <button
                      type="button"
                      onClick={(e) => handleShare(e, ticket.id)}
                      style={{
                        backgroundColor: "#5656FF",
                        color: "white",
                        padding: "5px 10px",
                        borderRadius: "4px",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: window.innerWidth <= 576 ? "13px" : "14px",
                        width: "100%"
                      }}
                    >
                      <Share fontSize="small" style={{ marginRight: "4px" }} /> Compartir
                    </button>
                  </div>

                  <div style={{
                    marginTop: '12px',
                    display: 'flex',
                    textAlign: 'center',
                    justifyContent: 'center',
                    fontSize: '12px',
                    color: '#71717A',
                    fontFamily: "Bricolage Grotesque"
                  }}>
                    <span>Ticket #{ticket.id}</span>
                  </div>
                </CardContent>
              </Card>
            ))}

            {compra?.tickets?.length === 0 && (
              <div className="text-center w-100 py-4">
                <p style={{ color: '#71717A' }}>No hay tickets disponibles</p>
              </div>
            )}
          </div>
        </div>
      )}
      <Modal
        open={expandedImage !== null}
        onClose={handleCloseImage}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            outline: 'none',
            width: '90%',
            maxWidth: '90vw',
            height: '90%',
            maxHeight: '90vh',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center'
          }}
          onClick={handleCloseImage}
        >
          {expandedImage && (
            <img
              src={getTicketImageUrl(expandedImage)}
              alt={`Ticket expandido ${expandedImage}`}
              style={{
                maxWidth: '100%',
                maxHeight: '100%',
                objectFit: 'contain',
                boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
                borderRadius: '8px'
              }}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = NotDesign;
              }}
            />
          )}
          <div
            style={{
              marginTop: '20px',
              color: 'white',
              fontSize: '14px',
              textAlign: 'center',
              fontFamily: "Bricolage Grotesque",
              textShadow: '0 2px 4px rgba(0,0,0,0.5)'
            }}
          >
            (Haz clic en cualquier lugar para cerrar)
          </div>
        </div>
      </Modal>

      {currentTicket && (
        <TicketShareModal
          open={shareModalOpen}
          setShareModalOpen={setShareModalOpen}
          onClose={handleCloseShareModal}
          ticketId={currentTicket}
          eventoNombre={compra?.carrito?.evento?.evento || 'Evento'}
          ticketTipo={compra?.tickets?.find(t => t.id === currentTicket)?.tarifa?.concepto || 'Ticket'}
          showLoader={(loading) => setDownloadingTickets(prev => ({ ...prev, [currentTicket]: loading }))}
          ticketName={compra?.tickets?.find(t => t.id === currentTicket)?.nombre}
        />
      )}
    </div>
  );
}

export default withAuthenticationRequired(Compra, {
  onRedirecting: () => <Loading />,
});